import { createContext, ReactNode, useState, useEffect, useContext, useCallback } from 'react';
import { IRestaurant } from '@/views/OrdersTableView/types';
import { accessTokenKey, chosenRestaurantIdKey, restaurantDataKey } from '@/config/axios';
import RestaurantService from '@/services/restaurant';

export type RestaurantProductTypes = 'qlub' | 'qsr' | 'softpos';

interface IRestaurantContext {
    restaurant: IRestaurant | null;
    setRestaurant: ((val: IRestaurant | null) => void) | any;
    selectedProductType: RestaurantProductTypes | null;
    setSelectedProductType: ((val: RestaurantProductTypes | null) => void) | any;
    selectedQrGroup: string | null;
    setSelectedQrGroup: ((val: string | null) => void) | any;
}

const getLSRestaurant = (): IRestaurant | null => {
    try {
        const item = localStorage.getItem(restaurantDataKey);
        if (item) {
            return JSON.parse(item);
        }
    } catch {
        return null;
    }
    return null;
};

const setLSRestaurant = (item: IRestaurant | null) => {
    localStorage.setItem(restaurantDataKey, JSON.stringify(item));
};

const RestaurantContext = createContext<IRestaurantContext>({
    restaurant: null,
    setRestaurant: null,
    selectedProductType: null,
    setSelectedProductType: null,
    selectedQrGroup: null,
    setSelectedQrGroup: null,
});

type Props = {
    children?: ReactNode;
};

export function RestaurantContextProvider({ children }: Props) {
    const restaurantService = RestaurantService.getInstance();
    const [restaurant, setRestaurant] = useState<IRestaurant | null>(getLSRestaurant());
    const [selectedQrGroup, setSelectedQrGroup] = useState<string | null>(null);
    const [selectedProductType, setSelectedProductType] = useState<RestaurantProductTypes | null>(null);

    useEffect(() => {
        const token = localStorage.getItem(accessTokenKey);
        const restaurantId = localStorage.getItem(chosenRestaurantIdKey);
        if (token && restaurantId) {
            restaurantService
                .getRestaurant(restaurantId)
                .then((data) => {
                    return {
                        ...data,
                        brand_verification_sent: restaurant?.brand_verification_sent,
                    };
                })
                .then((data) => {
                    setRestaurant(data);
                    setLSRestaurant(data);
                })
                .catch((err) => console.log(err));
        }
    }, [restaurant?.id]);

    const setRestaurantHandler = useCallback((val: IRestaurant | null) => {
        setRestaurant(val);
        setLSRestaurant(val);
    }, []);

    return (
        <RestaurantContext.Provider
            // eslint-disable-next-line react/jsx-no-constructed-context-values
            value={{
                restaurant,
                setRestaurant: setRestaurantHandler,
                selectedProductType,
                setSelectedProductType,
                selectedQrGroup,
                setSelectedQrGroup,
            }}
        >
            {children}
        </RestaurantContext.Provider>
    );
}

export const useRestaurantContext = () => useContext(RestaurantContext);
